import clsx from "clsx";

import { FCCC } from "@/types";

export interface CardContainerProps {
  dataTestid?: string;
  variant?: "ivory" | "white";
}

export const CardContainer: FCCC<CardContainerProps> = ({
  dataTestid,
  className,
  children,
  variant = "white",
}) => (
  <div
    data-testid={dataTestid}
    className={clsx(
      variant === "white" ? "bg-background-primary" : "bg-background-secondary",
      className,
    )}
  >
    {children}
  </div>
);
